import React, { useContext } from 'react'
import ProfileContext from '@/components/Context/ProfileContext'
import EsAutocomplete from '@/components/Search/EsAutocomplete'

const Search = () => {
  const { isAuthenticated, loadingProfile } = useContext(ProfileContext)

  if (loadingProfile || !isAuthenticated) return null

  return <EsAutocomplete />
}

export default Search
